import { createReducer } from 'redux-starter-kit';
import { addStatusMessage, dismissStatusMessage } from '../actions/status';

export default createReducer(
  {
    messages: []
  },
  {
    [addStatusMessage]: (state, action) => ({
      ...state,
      messages: [...state.messages, action.payload]
    }),
    [dismissStatusMessage]: (state, action) => {
      const index = state.messages.indexOf(action.payload);
      let messages = [...state.messages];
      messages.splice(index, 1);
      return {
        ...state,
        messages
      };
    }
  }
);
